<template>
  <div class="scan-history mx-3 mt-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="mb-0"><font-awesome-icon :icon="['fas', 'clock-rotate-left']" /> 読込履歴</h6>
      <div v-if="availableDates.length > 1" class="btn-group btn-group-sm">
        <button
          v-for="date in availableDates"
          :key="date"
          class="btn"
          :class="date === selectedDate ? 'btn-primary' : 'btn-outline-secondary'"
          @click="$emit('update:selectedDate', date)"
        >{{ formatDateLabel(date) }}</button>
      </div>
    </div>

    <div v-if="entries.length === 0" class="text-muted small">履歴はありません</div>

    <div class="history-list" v-else>
      <div
        v-for="(entry, i) in entries"
        :key="i"
        class="history-item d-flex align-items-center py-1 border-bottom"
      >
        <span class="history-time text-muted me-2">{{ entry.date }} {{ entry.time }}</span>
        <span class="history-key me-2 fw-bold">{{ entry.matchKey }}</span>
        <span class="badge" :class="badgeClass(entry.result)">{{ resultLabel(entry.result) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  entries: { type: Array, required: true },
  availableDates: { type: Array, required: true },
  selectedDate: { type: String, required: true }
})

defineEmits(['update:selectedDate'])

const badgeClass = (result) => {
  switch (result) {
    case 'success': return 'bg-success'
    case 'error': return 'bg-danger'
    case 'confirmation': return 'bg-warning text-dark'
    default: return 'bg-secondary'
  }
}

const resultLabel = (result) => {
  switch (result) {
    case 'success': return '成功'
    case 'error': return 'エラー'
    case 'confirmation': return '確認'
    default: return result
  }
}

const formatDateLabel = (dateStr) => {
  const d = new Date(dateStr + 'T00:00:00')
  return `${d.getMonth() + 1}/${d.getDate()}`
}
</script>

<style scoped>
.scan-history {
  font-size: 0.9rem;
}

.history-list {
  max-height: 200px;
  overflow-y: auto;
}

.history-time {
  font-size: 0.75rem;
  min-width: 130px;
  white-space: nowrap;
}

.history-key {
  font-size: 0.85rem;
}
</style>
